import { HttpClient } from 'api/http-client';
export var CustomerPortalInviteMethod = /*#__PURE__*/ function(CustomerPortalInviteMethod) {
    CustomerPortalInviteMethod["EmailsFromCustomerDomainsAndAdditionalDomains"] = "EMAILS_FROM_CUSTOMER_DOMAINS_AND_ADDITIONAL_DOMAINS";
    CustomerPortalInviteMethod["AnyoneWithTheLink"] = "ANYONE_WITH_THE_LINK";
    return CustomerPortalInviteMethod;
}({});
export var AccountCustomerPortalType = /*#__PURE__*/ function(AccountCustomerPortalType) {
    AccountCustomerPortalType["Old"] = "OLD";
    AccountCustomerPortalType["New"] = "NEW";
    return AccountCustomerPortalType;
}({});
export var CustomerPortalSettingsAlgorithm = /*#__PURE__*/ function(CustomerPortalSettingsAlgorithm) {
    CustomerPortalSettingsAlgorithm["RS256"] = "RS256";
    CustomerPortalSettingsAlgorithm["HS256"] = "HS256";
    return CustomerPortalSettingsAlgorithm;
}({});
export var CustomerPortalSettingsMechanism = /*#__PURE__*/ function(CustomerPortalSettingsMechanism) {
    CustomerPortalSettingsMechanism["SharedSecret"] = "SHARED_SECRET";
    CustomerPortalSettingsMechanism["PublicPrivateKeyPair"] = "PUBLIC_PRIVATE_KEY_PAIR";
    return CustomerPortalSettingsMechanism;
}({});
class AccountCustomerPortalSettingsHttpClient extends HttpClient {
    getEmbedSettings() {
        return this.get('/settings/customer-portal/embed-settings');
    }
    getInviteSettings() {
        return this.get('/settings/customer-portal/invite-settings');
    }
    updateEmbedSettings(payload) {
        return this.post('/settings/customer-portal/embed-settings', payload);
    }
    updateInviteSettings(payload) {
        return this.post('/settings/customer-portal/invite-settings', payload);
    }
    switchToNew() {
        return this.post('/settings/customer-portal/switch-to-new');
    }
    generateSecretKey(payload) {
        return this.post('/settings/customer-portal/generate-secret', payload);
    }
    isRedirectEnabled() {
        return this.get('/settings/customer-portal/redirect/enable');
    }
    getCodeBlock() {
        return this.get('/settings/customer-portal/code-block');
    }
    isRTEEnabledInCpMultiLineText() {
        return this.get('/settings/customer-portal/rich-text/enable');
    }
}
export const CustomerPortalSettingsApi = new AccountCustomerPortalSettingsHttpClient();
